<template>
  <div class="page flex-col">
    <div class="main_container flex-col">
      <div class="hero_section flex-col justify-center">
        <div class="hero_content flex-col">
          <div class="header_nav flex-row">
            <img
              class="logo_icon"
              referrerpolicy="no-referrer"
              src="@/assets/home2/FigmaDDSSlicePNG65666e264c552b1f49975451fa6cfa78.png"
            />
            <span class="brand_name">悦韵</span>
            <div
              class="teacher_login_btn flex-col"
              @click="onClickToTeacher"
            >
              <span class="login_text">教师登录</span>
            </div>
          </div>
          <div class="hero_image_container flex-row">
            <img
              class="hero_banner"
              referrerpolicy="no-referrer"
              src="@/assets/home2/FigmaDDSSlicePNG2e7f643ffa4ee75a812e399838d7129c.png"
            />
          </div>
          <div class="slogan_container flex-row">
            <div class="slogan_wrapper flex-col">
              <span class="slogan_text">玩出来的AI编程课</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_section flex-col">
        <div class="footer_bg flex-col justify-end">
          <img
            class="footer_decorator"
            referrerpolicy="no-referrer"
            src="@/assets/home2/FigmaDDSSlicePNGa3eb0b3607c33a45a3f5bd67d4e7d81f.png"
          />
          <div class="footer_links flex-row">
            <span class="footer_link">联系我们</span>
            <span class="footer_link">条款及细则</span>
            <span class="footer_link">隐私政策</span>
          </div>
        </div>
        <div class="announcement_banner flex-col">
          <span class="announcement_text">编程学习平台，现已正式开放！</span>
          <div
            class="student_entry_btn flex-row"
            @click="onClick"
          >
            <img
              class="entry_icon"
              referrerpolicy="no-referrer"
              src="@/assets/home2/FigmaDDSSlicePNG4d28c6ebbc775b21b9a8c5a8998419de.png"
            />
            <span class="entry_text">学生入口</span>
          </div>
        </div>
        <img
          class="footer_character_1"
          referrerpolicy="no-referrer"
          src="@/assets/home2/FigmaDDSSlicePNGa9d70474006d9f6cd92ca3ccd6280af1.png"
        />
        <img
          class="footer_character_2"
          referrerpolicy="no-referrer"
          src="@/assets/home2/FigmaDDSSlicePNG3cda087d08c3f292cf8b4c87f194c3ad.png"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"
const router = useRouter()

const onClick = () => {
  router.push({ path: "/student/login" })
}

const onClickToTeacher = () => {
  router.push({ path: "/teacher/login" })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 100%;
  height: 56.25vw;
  overflow: hidden;
}

.main_container {
  height: 52.92vw;
  background: url(@/assets/home2/FigmaDDSSlicePNG1d47d3053188861b7597b63cc55f2301.png)
    100% no-repeat;
  background-size: 100% 100%;
  width: 111.1vw;
  position: relative;
  margin: -2.13vw 0 0 -5.52vw;
}

.hero_section {
  height: 33.34vw;
  width: 100vw;
  margin: 2.81vw 0 0 5.52vw;
}

.hero_content {
  height: 33.34vw;
  width: 100vw;
}

.header_nav {
  width: 96.41vw;
  height: 2.56vw;
  margin-left: 2.14vw;
}

.logo_icon {
  width: 2.56vw;
  height: 2.56vw;
}

.brand_name {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.41vw 0 0 0.5vw;
}

.teacher_login_btn {
  background-color: rgba(138, 251, 255, 0.12);
  border-radius: 8px;
  height: 2.4vw;
  border: 2px solid rgba(255, 255, 255, 1);
  width: 7.3vw;
  margin: 0.15vw 0 0 81.4vw;
  cursor: pointer;
}

.login_text {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.2vw 0 0 1.14vw;
}

.hero_image_container {
  width: 35.79vw;
  height: 3.29vw;
  margin: 12.39vw 0 0 17.13vw;
}

.hero_banner {
  width: 35.79vw;
  height: 3.29vw;
}

.slogan_container {
  width: 19.33vw;
  height: 2.97vw;
  margin: 1.82vw 0 10.31vw 17.13vw;
}

.slogan_wrapper {
  background-image: linear-gradient(
    90deg,
    rgba(94, 134, 255, 0.6) 0,
    rgba(90, 63, 241, 0.6) 100%
  );
  border-radius: 32px;
  height: 2.97vw;
  width: 19.33vw;
}

.slogan_text {
  width: 13.75vw;
  height: 2.24vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.66vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 2.2vw;
  margin: 0.41vw 0 0 2.76vw;
}

.footer_section {
  background-color: rgba(239, 246, 255, 1);
  position: absolute;
  left: 5.53vw;
  top: 40.58vw;
  width: 100vw;
  height: 16.1vw;
}

.footer_bg {
  background-image: linear-gradient(
    180deg,
    rgba(238, 244, 249, 0) 0,
    rgba(115, 146, 176, 0.18) 100%
  );
  position: absolute;
  left: 0;
  top: 5.06vw;
  width: 100vw;
  height: 12.77vw;
}

.footer_decorator {
  width: 13.81vw;
  height: 8.75vw;
  margin: 0.31vw 0 0 55.88vw;
}

.footer_links {
  background-color: rgba(247, 251, 255, 1);
  width: 100vw;
  height: 1.72vw;
  margin-top: 1.98vw;
}

.footer_link {
  width: 3.34vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.84vw;
  margin: 0.31vw 0 0 42.5vw;
}

.footer_link:nth-child(2) {
  width: 4.17vw;
  margin: 0.31vw 0 0 2.08vw;
}

.footer_link:nth-child(3) {
  width: 3.34vw;
  margin: 0.31vw 42.5vw 0 2.08vw;
}

.announcement_banner {
  box-shadow: 0px 4px 9px 1px rgba(34, 41, 75, 0.09);
  background-color: rgba(102, 163, 255, 1);
  height: 4.54vw;
  width: 100vw;
  position: absolute;
  left: 0;
  top: -2.03vw;
}

.announcement_text {
  width: 28.29vw;
  height: 1.93vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.45vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
  line-height: 1.93vw;
  margin: 1.19vw 0 0 38.48vw;
}

.student_entry_btn {
  background-image: linear-gradient(
    274deg,
    rgba(35, 72, 255, 1) 0,
    rgba(20, 157, 255, 1) 45.577821%,
    rgba(5, 238, 255, 1) 100%
  );
  border-radius: 64px 0px 64px 0px;
  position: absolute;
  left: 67.56vw;
  top: -1.51vw;
  width: 32.45vw;
  height: 6.05vw;
  cursor: pointer;
}

.entry_icon {
  width: 2.5vw;
  height: 2.5vw;
  margin: 1.92vw 0 0 2.34vw;
}

.entry_text {
  width: 8.34vw;
  height: 2.77vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 2.08vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 2.77vw;
  margin: 1.66vw 18.02vw 0 1.25vw;
}

.footer_character_1 {
  position: absolute;
  left: 26.93vw;
  top: -1.35vw;
  width: 25.11vw;
  height: 16.72vw;
}

.footer_character_2 {
  position: absolute;
  left: 40.94vw;
  top: 3.34vw;
  width: 16.36vw;
  height: 11.72vw;
}
</style>
